import React from 'react'

import * as styles from './resellerQuote.module.scss'
import Hero from 'common/Hero'

export default function ResellerQuote({ media, hat, title, subtitle }) {
  return (
    <Hero
      className={styles.section}
      mediaClassName="breakout"
      hat={`"`}
      hatAs="h1"
      title={title}
      titleAs="h3"
      subtitle={subtitle}
      subtitleAs="body2"
      media={media}
    />
  )
}
